import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/Layout";
import Loader from "../../components/Loader";
import General from "./General";
import StoreInformation from "./StoreInformation";
import ServiceList from "./ServiceList";
import ProductsList from "./ProductsList";
import {
  useFetchStoreQuery,
  useFetchStoreServicesQuery,
  useFetchStoreProductsQuery,
  useFetchRequestStoreQuery,
} from "../../store/services/storeService";
import { useSelector } from "react-redux";

const RequestStoreDetails = () => {

  const { id } = useParams();
  const words = useSelector((state) => state.authReducer.words);
  const { data: storeData, isLoading } = useFetchRequestStoreQuery(id);
  
  const tabs = [
    {
      label: words["store information"],
      value: "store-information",
    },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0].value);


  return (
    <Layout
      pageTitle={words["store details"]}
    >
      <div className="w-full min-h-screen flex">
        {isLoading ? (
          <div className="wrap wrapWidth flex flex-col items-center ">
            <Loader />
          </div>
        ) : (
          <div className="wrap wrapWidth flex flex-col">
            <div className="flex flex-col gap-6 mt-6">
              <div className="flex w-full border-b-2 border-b-[#CD454A] border-transparent ">
                {tabs.map((item, index) => (
                  <button
                    key={index}
                    className={`btn font-semibold rounded ${activeTab === item.value
                      ? " bg-[#CD454A] text-white"
                      : "bg-transparent text-[#CD454A]"
                      }`}
                    onClick={(e) => setActiveTab(item.value)}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
              {activeTab === "general" && <General data={storeData?.statics} />}
              {activeTab === "store-information" && (
                <StoreInformation data={storeData?.data ?? {}} />
              )}
             
              {activeTab === "reviews" && <ProductsList />}
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default RequestStoreDetails;
